import { CurrentUserRepository } from '../../domain/repositories/CurrentUserRepository'
import { UserModel } from '../models/UserModel'
import type { UserEntity } from '../../domain/entities/UserEntity'
import { type UserDto } from '@/backend/market'
import { UserRolesModel } from '../models/UserRolesModel'
import type { UserRolesEntity } from '../../domain/entities/UserRolesEntity'
import { UsersService } from '@/backend/market'
import { UsersService as AuthService } from '@/backend/auth'

export class CurrentUserRepositoryImpl implements CurrentUserRepository {
  async getCurrentUser(): Promise<UserEntity | { error: true }> {
    try {
      const response = await UsersService.getCurrentUserAdmin()
      const userModel = new UserModel(response as UserDto)

      return userModel
    } catch {
      return { error: true }
    }
  }
  async getCurrentUserRoles(): Promise<UserRolesEntity | { error: true }> {
    try {
      const response = await UsersService.getCurrentUserRolesAdmin()
      const userRoleModel = new UserRolesModel(response)

      return userRoleModel
    } catch {
      return { error: true }
    }
  }
  async getCurrentUserAuthRoles(): Promise<UserRolesEntity | { error: true }> {
    try {
      const response = await AuthService.getCurrentUserRolesAdmin()
      const userRoleModel = new UserRolesModel(response)

      return userRoleModel
    } catch {
      return { error: true }
    }
  }
}
